import styled from 'styled-components';

export const Footer = styled.footer`
  flex-shrink: 0;
  width: 100%;
  height: auto;
  width: auto;
  padding-left: 5px;

  @media (max-width: 1025px) {
    &.navCollapsed {
      margin-left: 48px;
      width: 100%;
    }

    &.navExpanded {
      margin-left: 228px;
      width: calc(100% - 228px);
    }
  }
  
  @media (min-width: 1026px) {
    &.navCollapsed {
      margin-left: 48px;
      width: calc(100% - 48px);
    }

    &.navExpanded {
      margin-left: 228px;
      width: calc(100% - 228px);
    }
  }
`;
